import type { StyleParamValue } from 'root/components/Menus/stylesParams';
import { Preset } from 'root/utils/presets';
import { useGetLayoutStylesParams } from 'root/hooks/useGetLayoutStylesParams';

export const useGetNavigationFullWidthTab = (preset: Preset) => {
  const {
    gridMenuNavigationFullWidthTab,
    columnsMenuNavigationFullWidthTab,
    centerMenuNavigationFullWidthTab,
    sideBySideMenuNavigationFullWidthTab,
  } = useGetLayoutStylesParams();

  const navigationFullWidthTabMap: Record<Preset, StyleParamValue> = {
    [Preset.Grid]: gridMenuNavigationFullWidthTab,
    [Preset.Columns]: columnsMenuNavigationFullWidthTab,
    [Preset.Center]: centerMenuNavigationFullWidthTab,
    [Preset.SideBySide]: sideBySideMenuNavigationFullWidthTab,
  };

  return navigationFullWidthTabMap[preset];
};
